import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`
})
export class AppComponent {
  _jsonURL: string = 'assets/config.json';
  // /Users/reem/Desktop/IdeasHub/src/ui/src/assets/config.json
  constructor(    private _http: HttpClient,  ) {
    this.getJSON().subscribe(
      (value) => {
        localStorage.setItem('apiUrl', value.apiUrl);
      },
      (err) => {}
    );
    
  }
  public getJSON(): Observable<any> {
    return this._http.get(this._jsonURL);
  }
  

}
